import { render, staticRenderFns } from "./structuralModification.vue?vue&type=template&id=576d02d1&scoped=true&"
import script from "./structuralModification.vue?vue&type=script&lang=js&"
export * from "./structuralModification.vue?vue&type=script&lang=js&"
import style0 from "./structuralModification.vue?vue&type=style&index=0&id=576d02d1&lang=less&scoped=true&"
import style1 from "./structuralModification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d02d1",
  null
  
)

export default component.exports